/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MemberStatus } from './MemberStatus';
import {
    MemberStatusFromJSON,
    MemberStatusFromJSONTyped,
    MemberStatusToJSON,
} from './MemberStatus';

/**
 * Member Schema
 * @export
 * @interface Member
 */
export interface Member {
    /**
     * Member ID
     * @type {string}
     * @memberof Member
     */
    id: string;
    /**
     * Account ID
     * @type {string}
     * @memberof Member
     */
    accountId: string | null;
    /**
     * Given Name
     * @type {string}
     * @memberof Member
     */
    givenName: string;
    /**
     * Family Name
     * @type {string}
     * @memberof Member
     */
    familyName: string;
    /**
     * Street Address
     * @type {string}
     * @memberof Member
     */
    streetAddress: string;
    /**
     * City
     * @type {string}
     * @memberof Member
     */
    city: string;
    /**
     * State ID
     * @type {number}
     * @memberof Member
     */
    stateId: number;
    /**
     * Zip Code
     * @type {string}
     * @memberof Member
     */
    zipCode: string;
    /**
     * Date Joined
     * @type {Date}
     * @memberof Member
     */
    dateJoined: Date;
    /**
     * Notes
     * @type {string}
     * @memberof Member
     */
    notes: string;
    /**
     * 
     * @type {MemberStatus}
     * @memberof Member
     */
    status: MemberStatus;
    /**
     * Descendant Of
     * @type {string}
     * @memberof Member
     */
    descendantOf: string;
    /**
     * Is Active
     * @type {boolean}
     * @memberof Member
     */
    isActive: boolean;
    /**
     * Sponsored By Member ID
     * @type {string}
     * @memberof Member
     */
    sponsoredByMemberId: string | null;
    /**
     * Created Date
     * @type {Date}
     * @memberof Member
     */
    createdDate: Date;
    /**
     * Updated Date
     * @type {Date}
     * @memberof Member
     */
    updatedDate: Date;
}



/**
 * Check if a given object implements the Member interface.
 */
export function instanceOfMember(value: object): value is Member {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('streetAddress' in value) || value['streetAddress'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('stateId' in value) || value['stateId'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('dateJoined' in value) || value['dateJoined'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('descendantOf' in value) || value['descendantOf'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('sponsoredByMemberId' in value) || value['sponsoredByMemberId'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    return true;
}

export function MemberFromJSON(json: any): Member {
    return MemberFromJSONTyped(json, false);
}

export function MemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): Member {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'accountId': json['account_id'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'streetAddress': json['street_address'],
        'city': json['city'],
        'stateId': json['state_id'],
        'zipCode': json['zip_code'],
        'dateJoined': (new Date(json['date_joined'])),
        'notes': json['notes'],
        'status': MemberStatusFromJSON(json['status']),
        'descendantOf': json['descendant_of'],
        'isActive': json['is_active'],
        'sponsoredByMemberId': json['sponsored_by_member_id'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
    };
}

export function MemberToJSON(value?: Member | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'account_id': value['accountId'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'street_address': value['streetAddress'],
        'city': value['city'],
        'state_id': value['stateId'],
        'zip_code': value['zipCode'],
        'date_joined': ((value['dateJoined']).toISOString()),
        'notes': value['notes'],
        'status': MemberStatusToJSON(value['status']),
        'descendant_of': value['descendantOf'],
        'is_active': value['isActive'],
        'sponsored_by_member_id': value['sponsoredByMemberId'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
    };
}

